var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InputFieldType } from 'models/Input/InputModels';
import { useEffect, useState } from 'react';
import { dateFormatHelper } from 'utils/date-format-helper';
import { priceService } from 'services/api/price-service';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CURRENCY_ARRAY, CURRENCY_LIST } from 'utils/constants';
import { InputFieldsContainer } from '../InputFieldsContainer/InputFieldsContainer';
import styles from './QuickPriceDetails.module.scss';
import { PubTable } from '../PubTable/PubTable';
import { LoadingSpinner } from '../Loading/LoadingSpinner/LoadingSpinner';
var DISCOUNT_CODE = 'discountCode';
var PRODUCT_NUMBER = 'inputProductNbr';
var LEAD_TIME = 'minLeadtime';
var PRICELIST_DATE = 'priceListDate';
var LISTPRICE = 'Listprice';
var CURRENCY = 'Currency';
export function QuickPriceDetails(_a) {
    var _b, _c;
    var _d, _e, _f;
    var effectiveDate = _a.effectiveDate, productReference = _a.productReference, validationResp = _a.validationResp, showPriceTable = _a.showPriceTable, modalName = _a.modalName, currency = _a.currency, noGetListPriceCall = _a.noGetListPriceCall, listPriceResponse = _a.listPriceResponse, gsaInd = _a.gsaInd;
    var colDef = {
        rowGap: '5px',
        fields: (_b = {},
            _b[DISCOUNT_CODE] = {
                fieldName: 'Discount Code:',
                displaySeq: 2,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[LEAD_TIME] = {
                fieldName: 'Lead Time:',
                displaySeq: 3,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[PRODUCT_NUMBER] = {
                fieldName: 'Product Number:',
                displaySeq: 1,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[CURRENCY] = {
                fieldName: 'Currency:',
                displaySeq: 4,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[PRICELIST_DATE] = {
                fieldName: 'Price List Date:',
                displaySeq: 6,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[LISTPRICE] = {
                fieldName: 'List Price:',
                displaySeq: 5,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b),
    };
    var colDef2 = {
        rowGap: '2px',
        fields: (_c = {},
            _c[PRICELIST_DATE] = {
                fieldName: 'Price List Date:',
                displaySeq: 1,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _c[LISTPRICE] = {
                fieldName: 'List Price:',
                displaySeq: 2,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _c),
    };
    var buildFieldValues2 = function (date, priceTotal, listPriceReturnCode) {
        var _a;
        return (_a = {},
            _a[PRICELIST_DATE] = {
                value: listPriceReturnCode === 0 ? date : '---',
            },
            _a[LISTPRICE] = {
                value: listPriceReturnCode === 0 ? "$".concat(priceTotal === null || priceTotal === void 0 ? void 0 : priceTotal.toFixed(2)) : '---',
            },
            _a);
    };
    var buildFieldValues = function (dataBody) {
        var _a;
        var _b;
        return (_a = {},
            _a[PRODUCT_NUMBER] = {
                value: dataBody === null || dataBody === void 0 ? void 0 : dataBody.productNbr,
            },
            _a[LEAD_TIME] = {
                value: dataBody === null || dataBody === void 0 ? void 0 : dataBody.minLeadtime,
            },
            _a[DISCOUNT_CODE] = {
                value: dataBody === null || dataBody === void 0 ? void 0 : dataBody.discountCode,
            },
            _a[CURRENCY] = {
                value: (dataBody === null || dataBody === void 0 ? void 0 : dataBody.currencyCode) === CURRENCY_LIST.CAD ? CURRENCY_ARRAY.CAD : CURRENCY_ARRAY.USD,
            },
            _a[PRICELIST_DATE] = {
                value: (dataBody === null || dataBody === void 0 ? void 0 : dataBody.listPriceReturnCode) === 0 ? dataBody === null || dataBody === void 0 ? void 0 : dataBody.priceDate : '---',
            },
            _a[LISTPRICE] = {
                value: (dataBody === null || dataBody === void 0 ? void 0 : dataBody.listPriceReturnCode) === 0 ? "$".concat((_b = dataBody === null || dataBody === void 0 ? void 0 : dataBody.priceTotal) === null || _b === void 0 ? void 0 : _b.toFixed(2)) : '---',
            },
            _a);
    };
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(), listPriceRespbody = _h[0], setListPriceRespbody = _h[1];
    var _j = useState(), features = _j[0], setFeatures = _j[1];
    var _k = useState({
        productNbr: '',
        minLeadtime: 0,
        discountCode: '',
        currencyCode: '',
        priceDate: '',
        priceTotal: 0,
        listPriceReturnCode: 0,
    }), headerData = _k[0], setHeaderData = _k[1];
    var _l = useState(buildFieldValues2(dateFormatHelper.formatDateMMddyyyyWithHyphen((_d = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.priceDate) !== null && _d !== void 0 ? _d : ''), currency === CURRENCY_LIST.USD
        ? (_e = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.totalListPrice) !== null && _e !== void 0 ? _e : 0
        : (_f = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.totalListPriceCAD) !== null && _f !== void 0 ? _f : 0, Number(listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnCode))), fieldValues2 = _l[0], setFieldValues2 = _l[1];
    var _m = useState(buildFieldValues(headerData)), fieldValues = _m[0], setFieldValues = _m[1];
    var _o = useState({}), tableData = _o[0], setTableData = _o[1];
    useEffect(function () {
        (function initialGetPrice() {
            return __awaiter(this, void 0, void 0, function () {
                var date, request, rsp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!productReference)
                                return [2 /*return*/];
                            setLoading(true);
                            if (!noGetListPriceCall) return [3 /*break*/, 1];
                            setListPriceRespbody(listPriceResponse);
                            return [3 /*break*/, 3];
                        case 1:
                            date = modalName === 'QuickPrice'
                                ? dateFormatHelper.todaysDateFormattedLocale({ format: 'yyyyMMdd' }, new Date(effectiveDate))
                                : dateFormatHelper.formattedDateInyyyyMMdd(effectiveDate);
                            request = {
                                effectiveDate: date,
                                productNumber: productReference !== null && productReference !== void 0 ? productReference : '',
                            };
                            if (gsaInd) {
                                request.gsaInd = gsaInd;
                            }
                            return [4 /*yield*/, priceService.getListPrice(request)];
                        case 2:
                            rsp = _a.sent();
                            setListPriceRespbody(rsp.body);
                            _a.label = 3;
                        case 3:
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (validationResp && 'features' in validationResp) {
            setFeatures(validationResp.features);
            var discountVal = "".concat(validationResp.discountDesc, " (").concat(validationResp.discountCode, ")");
            var priceDateVal = dateFormatHelper.formatDateMMddyyyyWithHyphen((_a = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.priceDate) !== null && _a !== void 0 ? _a : '');
            var priceTotalVal = currency === CURRENCY_LIST.USD
                ? (_b = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.totalListPrice) !== null && _b !== void 0 ? _b : 0
                : (_c = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.totalListPriceCAD) !== null && _c !== void 0 ? _c : 0;
            var listPriceReturnCodeVal = Number(listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnCode);
            setHeaderData({
                productNbr: validationResp.productNbrOut,
                minLeadtime: validationResp.minLeadtime,
                discountCode: discountVal,
                currencyCode: currency,
                priceDate: priceDateVal,
                priceTotal: priceTotalVal,
                listPriceReturnCode: listPriceReturnCodeVal,
            });
            setFieldValues(buildFieldValues({
                productNbr: validationResp.productNbrOut,
                minLeadtime: validationResp.minLeadtime,
                discountCode: discountVal,
                currencyCode: currency,
                priceDate: priceDateVal,
                priceTotal: priceTotalVal,
                listPriceReturnCode: listPriceReturnCodeVal,
            }));
            setFieldValues2(buildFieldValues2(priceDateVal, priceTotalVal, listPriceReturnCodeVal));
            var data_1 = {};
            data_1[0] = {
                step: '',
                feature: "Base Product Number : ".concat(validationResp.baseProductNbr),
                priceCategory: '',
                option: '',
                listPrice: (_d = Number(getBasePrice(listPriceRespbody !== null && listPriceRespbody !== void 0 ? listPriceRespbody : {}, currency !== null && currency !== void 0 ? currency : '', noGetListPriceCall !== null && noGetListPriceCall !== void 0 ? noGetListPriceCall : false)).toLocaleString('en', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })) !== null && _d !== void 0 ? _d : '',
            };
            var dataIndex_1 = 0;
            features === null || features === void 0 ? void 0 : features.forEach(function (feature, i) {
                var _a, _b, _c, _d;
                if (feature.type !== 'Derived') {
                    var matchingOption = (_a = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.optionListResults) === null || _a === void 0 ? void 0 : _a.find(function (option) {
                        return option.code === feature.optionCode &&
                            option.optionDescription === feature.optionDescription &&
                            option.featureDescription === feature.featureDescription;
                    });
                    dataIndex_1 += 1;
                    data_1[dataIndex_1] = {
                        step: (_b = feature.step) !== null && _b !== void 0 ? _b : '',
                        feature: (_c = (feature.type === 'Base'
                            ? "(Base) ".concat(feature.featureDescription)
                            : feature.featureDescription)) !== null && _c !== void 0 ? _c : '',
                        priceCategory: (_d = matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.priceCategoryDesc) !== null && _d !== void 0 ? _d : '',
                        option: getOptionInfo(feature),
                        listPrice: matchingOption
                            ? Number(getListPriceForFeature(matchingOption, currency !== null && currency !== void 0 ? currency : '', noGetListPriceCall !== null && noGetListPriceCall !== void 0 ? noGetListPriceCall : false)).toLocaleString('en', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                            : '0.00',
                    };
                }
            });
            setTableData(data_1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [effectiveDate, features, listPriceRespbody, validationResp, currency]);
    var tableDataDefinition = {
        firstColumnIndent: true,
        columns: [
            {
                dataAttribute: 'step',
                fieldType: InputFieldType.NUMBER,
                heading: 'Step',
                width: '100px',
                showHelpTooltip: true,
            },
            {
                dataAttribute: 'feature',
                fieldType: InputFieldType.STRING,
                heading: 'Feature',
                width: '300px',
            },
            {
                dataAttribute: 'priceCategory',
                fieldType: InputFieldType.STRING,
                heading: 'Price Category',
                width: '200px',
            },
            {
                dataAttribute: 'option',
                fieldType: InputFieldType.STRING,
                heading: 'Option',
                width: '300px',
            },
            {
                dataAttribute: 'listPrice',
                fieldType: InputFieldType.STRING,
                heading: 'List Price',
                width: '100px',
                alignRight: true,
            },
        ],
    };
    var setEffectiveDateToLocalTime = function (date) {
        var newDate = new Date(date);
        var day = newDate.getDate().toString().length > 1 ? newDate.getDate() : "0".concat(newDate.getDate());
        var month = newDate.getMonth().toString().length > 1 ? newDate.getMonth() + 1 : "0".concat(newDate.getMonth() + 1);
        var year = newDate.getFullYear();
        var _a = newDate.toString().split(' ')[4].split(':'), h = _a[0], m = _a[1], s = _a[2];
        var hours = newDate.getHours();
        var isAm = hours < 12;
        var stringToPresent = "".concat(month, "-").concat(day, "-").concat(year, " ").concat(+hours > 12 ? +hours - 12 : hours, ":").concat(m, ":").concat(s, " ").concat(!isAm ? 'PM' : 'AM');
        return stringToPresent;
    };
    return (_jsxs(_Fragment, { children: [loading && _jsx(LoadingSpinner, { indicatorSize: 5 }), !loading && (_jsxs(Box, __assign({ sx: { marginBottom: '50px' } }, { children: [modalName === 'QuickPrice' && (_jsx(Box, __assign({ className: styles.quickPriceHeaderContainer }, { children: _jsxs(Box, __assign({ className: styles.quickPriceHeaderLeft, sx: { width: '50%', flexDirection: 'column' } }, { children: [_jsxs(Typography, __assign({ className: styles.quickPriceHeaderLeftText }, { children: ["Price Result for Requested List Price Effective on", ' ', setEffectiveDateToLocalTime(effectiveDate)] })), _jsx(InputFieldsContainer, { colDef: colDef, fieldValues: fieldValues, minHeight: "10px" }), Number(listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnCode) !== 0 && (_jsx(Typography, __assign({ className: styles.priceErrorText }, { children: listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnMessage })))] })) }))), modalName === 'NonContractPrice' && (_jsxs(Box, __assign({ className: styles.quickPriceHeaderContainer, sx: { backgroundColor: '#F1F0EF' } }, { children: [_jsxs(Box, __assign({ className: styles.quickPriceHeaderLeft, sx: { width: '50%', flexDirection: 'column' } }, { children: ["Requested List Price Effective on", ' ', dateFormatHelper.formatDateMMddyyyyWithHyphen(effectiveDate), Number(listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnCode) !== 0 && (_jsx(Typography, __assign({ className: styles.priceErrorText }, { children: listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnMessage })))] })), _jsx(Box, __assign({ className: styles.quickPriceHeaderRight, sx: { width: '50%' } }, { children: _jsx(InputFieldsContainer, { colDef: colDef2, fieldValues: fieldValues2, minHeight: "10px" }) }))] }))), showPriceTable && Number(listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.returnCode) === 0 && (_jsx(PubTable, { def: tableDataDefinition, tableData: tableData !== null && tableData !== void 0 ? tableData : {}, alternateRowBackgroundColor: true }))] })))] }));
}
function getOptionInfo(feature) {
    var _a, _b, _c;
    var optionInfo = '';
    var restrictedText = isOptionRestrictionPresent(feature.optionRestrictions) ? '(RESTRICTED)' : '';
    if (isFieldNotEmpty((_a = feature.optionCode) !== null && _a !== void 0 ? _a : '') && isFieldNotEmpty((_b = feature.optionDescription) !== null && _b !== void 0 ? _b : '')) {
        optionInfo = "".concat(feature.optionCode, " - ").concat(restrictedText, " ").concat(feature.optionDescription);
    }
    else if (isFieldNotEmpty((_c = feature.optionDescription) !== null && _c !== void 0 ? _c : '')) {
        optionInfo = "".concat(restrictedText, " ").concat(feature.optionDescription);
    }
    return optionInfo;
}
function isFieldNotEmpty(field) {
    var notEmpty = false;
    if (field && field !== '' && field !== null && field.trim().length > 0) {
        notEmpty = true;
    }
    return notEmpty;
}
function isOptionRestrictionPresent(field) {
    var optionRestrictionPresent = false;
    if (field !== null && field && field.length > 0) {
        optionRestrictionPresent = true;
    }
    return optionRestrictionPresent;
}
function getBasePrice(listPriceRespbody, currency, noGetListPriceCall) {
    var _a, _b, _c;
    var basePrice = 0;
    if (noGetListPriceCall) {
        basePrice = (_a = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.contractBasePrice) !== null && _a !== void 0 ? _a : 0;
    }
    else if (currency === CURRENCY_LIST.CAD) {
        basePrice = (_b = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.basePriceCAD) !== null && _b !== void 0 ? _b : 0;
    }
    else {
        basePrice = (_c = listPriceRespbody === null || listPriceRespbody === void 0 ? void 0 : listPriceRespbody.basePrice) !== null && _c !== void 0 ? _c : 0;
    }
    return basePrice;
}
function getListPriceForFeature(matchingOption, currency, noGetListPriceCall) {
    var _a, _b, _c;
    var listPrice = 0;
    if (noGetListPriceCall) {
        listPrice = (_a = matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.contractOptionListPrice) !== null && _a !== void 0 ? _a : 0;
    }
    else if (currency === CURRENCY_LIST.CAD) {
        listPrice = (_b = matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.optionPriceCAD) !== null && _b !== void 0 ? _b : 0;
    }
    else {
        listPrice = (_c = matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.optionPrice) !== null && _c !== void 0 ? _c : 0;
    }
    return listPrice;
}
